/********************************************
 * Crosslinks Carousel
 *
 * Flickity carousel
 * https://flickity.metafizzy.co/
 ********************************************/
function fnCrosslinksCarousel(i, oSection) {

    /*****************
     * Objects
     *****************/
    var oSection = $(oSection),
        oCarousel = $('.carousel', oSection),
        oArrows = $('.nav-arrows', oSection),
        oBar = $('.progress-bar', oSection),
        oSlides = $('.post-card', oSection),
        iCurrentSlide;


    /*****************
     * Carousel configuration
     *****************/

    /**
     * Initialise Flickity
     */

    function fnSliderInit() {
        if (oSlides.length > 1 && $(window).width() < 960) {
            var $oFlickity = oCarousel.flickity({
                watchCss: true,
                cellAlign: 'left',
                freeScroll: true,
                freeScrollFriction: 0.075,
                contain: true,
                accessibility: false,
                prevNextButtons: false,
                pageDots: false
            });

            /**
             * Store carousel data
             */
            var aCarouselData = $oFlickity.data('flickity'),
                iTotalSlides = aCarouselData.slides.length;

            /**
             * Arrow buttons (prev/next)
             */
            oArrows.find('.next').on('click', function () {
                $oFlickity.flickity('next');
            });
            oArrows.find('.previous').on('click', function () {
                $oFlickity.flickity('previous');
            });


            /**
             * Progress bar
             */
            // Update progress bar on load
            oBar.find( '.current' ).css( 'width', ( 100 / ( iTotalSlides - 1 ) ) * 1 + '%' );

            // On scroll
            $oFlickity.on( 'scroll.flickity', function( event, iProgress ) {

                // Current slide
                iCurrentSlide			= aCarouselData.selectedIndex + 1;

                // Calculate progress
                iSlideBarWidth			= 100 / ( iTotalSlides - 1 );
                iProgress				= ( ( iProgress * 100 ) + iSlideBarWidth );

                // Update progress bar
                oBar.find( '.current' ).css( 'width', iProgress + '%' );

            });

        }
    }

    fnSliderInit();

    $(window).resize(function () {
        fnSliderInit();
    });

}


// END OF DOCUMENT
